import React from 'react';

const Footer: React.FC = () => {
	return (
		<>
			<footer className="pt5 pb4 tc black-80">
				<hr className="bg-black-50 mb3" />
				North Pennines National Landscape
			</footer>
		</>
	);
};

export default Footer;
